import PlacingRequestHelp from '@/Components/Help/Clients/placingrequest'
import ActivatingProfessionalHelp from '@/Components/Help/Professionals/activatingprofessional'

export default {
  components: {
    PlacingRequestHelp,
    ActivatingProfessionalHelp,
  }
}
